var map = {
	"./1.png": 94575,
	"./10.png": 91903,
	"./2.png": 3732,
	"./3.png": 36765,
	"./4.png": 32514,
	"./5.png": 69995,
	"./6.png": 82352,
	"./7.png": 88601,
	"./8.png": 73038,
	"./9.png": 2263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56711;